import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import SetupPage from './pages/SetupPage';
import DashboardPage from './pages/DashboardPage';
import PostsPage from './pages/PostsPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import PricingPage from './pages/PricingPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import AdminPage from './pages/AdminPage';
import AccountPage from './pages/AccountPage';
import SettingsPage from './pages/SettingsPage';
import PostEditorPage from './pages/PostEditorPage';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import GA4Tracker from './components/GA4Tracker';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from 'sonner';

function App() {
  return (
    <>
      <GA4Tracker />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/app" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route index element={<Navigate to="/app/setup" replace />} />
              <Route path="setup" element={<SetupPage />} />
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="posts" element={<PostsPage />} />
              <Route path="account" element={<AccountPage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="posts/:postId/edit" element={<PostEditorPage />} />
            </Route>
            {/* Redirects for shortcut routes */}
            <Route path="/posts" element={<Navigate to="/app/posts" replace />} />
            <Route path="/setup" element={<Navigate to="/app/setup" replace />} />
            <Route path="/settings" element={<Navigate to="/app/settings" replace />} />
            <Route path="/dashboard" element={<Navigate to="/app/dashboard" replace />} />
            <Route path="/posts/:postId/edit" element={<ProtectedRoute><PostEditorPage /></ProtectedRoute>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </>
  );
}

export default App;
